import registerNavbarDirective from './NavbarDirective';
import FinishEarlyModalController from './modal/FinishEarlyModalController';


export default function registerNavbar(angular) {
    angular.module('assessmentFrontendControllers').controller('FinishEarlyModalController', ['$scope', '$uibModalInstance', 'task', '$location', 'countDown', '$bridges', '$timeout', '$config', FinishEarlyModalController]);
    registerNavbarDirective(angular.module('assessmentFrontendDirectives'));
}
